var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DotsThreeVertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6875 14C12.6875 14.7249 13.2751 15.3125 14 15.3125C14.7249 15.3125 15.3125 14.7249 15.3125 14C15.3125 13.2751 14.7249 12.6875 14 12.6875C13.2751 12.6875 12.6875 13.2751 12.6875 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.6875 14C19.6875 14.7249 20.2751 15.3125 21 15.3125C21.7249 15.3125 22.3125 14.7249 22.3125 14C22.3125 13.2751 21.7249 12.6875 21 12.6875C20.2751 12.6875 19.6875 13.2751 19.6875 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.6875 14C5.6875 14.7249 6.27513 15.3125 7 15.3125C7.72487 15.3125 8.3125 14.7249 8.3125 14C8.3125 13.2751 7.72487 12.6875 7 12.6875C6.27513 12.6875 5.6875 13.2751 5.6875 14Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.b0e8c0da6e268ee6fdd49240179c3703.svg";
export { ForwardRef as ReactComponent };